export default function Settings() {
  return (
    <div className="card">
      <h3>Settings</h3>
      <p>Put your app settings here (profile, payments, projects, etc.).</p>
    </div>
  );
}
